import Documentation, { DocumentationConstructorValues } from "./index";
export default class Group {
  id: number;
  name: string;
  index: string | number;
  documentations: Map<DocumentationId, Documentation> = new Map();

  constructor(params: GroupConstructorParams) {
    this.id = params.id;
    this.name = params.name;
    this.index = params.index;
    if (params.documentations) {
      this.documentations = params.documentations;
      this.resetDocumentationsParentGroup();
    }
  }

  public add(documentation: DocumentationConstructorValues): void {
    this.documentations.set(documentation.id, documentation);
    documentation.group = this;
  }

  public remove(id: DocumentationId): void {
    const doc = this.documentations.get(id);
    if (doc) {
      doc.group = null;
      this.documentations.delete(id);
    }
  }

  private resetDocumentationsParentGroup(): void {
    this.documentations.forEach((x) => (x.group = this));
  }
}

type DocumentationId = number;
interface GroupConstructorParams {
  id: number;
  name: string;
  index: string | number;
  documentations?: Map<DocumentationId, Documentation>;
}
